import React, { useState } from 'react';
import $i18n from '../../../../i18n';

const UrlsContent: React.FC<{ value: any }> = ({ value }) => {
  const [expanded, setExpanded] = useState(false); // 展开
  const arr = value?.split(',') || [];

  return (
    <div>
      {arr.map((vv, ii) => {
        if (expanded || ii < 2) {
          return (
            <div
              style={{
                color: '#585F7E',
                lineHeight: '16px',
                wordBreak: 'break-all',
                marginBottom: '8px',
              }}
            >
              {ii + 1}.{vv}
            </div>
          );
        }
      })}
      {arr.length > 2 && (
        <div>
          <a
            onClick={() => setExpanded(!expanded)}
            style={{ lineHeight: '20px', color: 'var(--superapp-primary-1)' }}
          >
            {expanded
              ? $i18n.get({ id: 'aopf.detail.redirectUrl.urlsContent.PackUpAll', dm: '收起全部' })
              : $i18n.get({ id: 'aopf.detail.redirectUrl.urlsContent.ExpandAll', dm: '展开全部' })}
          </a>
        </div>
      )}
    </div>
  );
};

export default UrlsContent;
